export default "//kitchen-prod-asset.oss-cn-shanghai.aliyuncs.com/kitchen/online/static/media/modal_designer.png";